var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "form"
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      size: "mini",
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      "label-width": "80px"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "催函方式"
    }
  }, [_c("cpsc-select", {
    attrs: {
      placeholder: "请选择催函方式"
    },
    model: {
      value: _vm.form.ReportNeed,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ReportNeed", $$v);
      },
      expression: "form.ReportNeed"
    }
  }, [_c("el-option", {
    attrs: {
      label: "短信",
      value: "短信"
    }
  }), _c("el-option", {
    attrs: {
      label: "电话",
      value: "电话"
    }
  }), _c("el-option", {
    attrs: {
      label: "电邮",
      value: "电邮"
    }
  }), _c("el-option", {
    attrs: {
      label: "其他",
      value: "其他"
    }
  })], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "催函人"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入催函人"
    },
    model: {
      value: _vm.form.a,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "a", $$v);
      },
      expression: "form.a"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "催函日期"
    }
  }, [_c("el-date-picker", {
    staticClass: "select date-select-no-icon app-form-component-select",
    attrs: {
      clearable: false,
      "value-format": "yyyy-MM-dd",
      type: "date"
    },
    model: {
      value: _vm.form.StartDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "StartDate", $$v);
      },
      expression: "form.StartDate"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "催函记录"
    }
  })], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")]), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("返回")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };